module.exports = __webpack_public_path__ + "static/img/TMBcharacterPhotos_0000_shadowMoon.b64871a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/TMBcharacterPhotos_0000_shadowMoon.jpg
// module id = OJkx
// module chunks = 1